var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgChevronLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 10.384 17.941"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.677.708L1.414 8.971l8.263 8.263",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2
  })));
}

export default __webpack_public_path__ + "11b88404772f121a18c9cd642acd31eb.svg";
export { SvgChevronLeft as ReactComponent };